import { render } from "./AdmissibleTrackingsSheet.vue?vue&type=template&id=c5167d92&ts=true"
import script from "./AdmissibleTrackingsSheet.vue?vue&type=script&lang=ts"
export * from "./AdmissibleTrackingsSheet.vue?vue&type=script&lang=ts"

import exportComponent from "/home/gitlab-deployer/builds/Bp7u02vYG/0/erp/admissibles-front/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__